import { Reveal, SectionHeading } from "@/components/Reveal";

const SLOTS = [1, 2, 3];

export default function ComingSoon() {
  return (
    <section id="more" data-testid="coming-soon-section" className="bg-ivory py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <SectionHeading eyebrow="More From MAHIRA" title="Our Journey Has Just Begun">
          MAHIRA is growing into a family of premium Indian agro-products.
          Every new product will be announced here first.
        </SectionHeading>
        <div className="mt-16 grid gap-5 md:grid-cols-3">
          {SLOTS.map((n) => (
            <Reveal key={n} delay={n * 0.08}>
              <div
                data-testid={`coming-soon-card-${n}`}
                className="group flex h-full min-h-[260px] flex-col items-center justify-center rounded-3xl border border-dashed border-forest/25 bg-white/40 p-10 text-center transition-[border-color,transform] duration-500 hover:-translate-y-1.5 hover:border-gold/60"
              >
                <span className="font-heading text-5xl text-gold/50">
                  {String(n).padStart(2, "0")}
                </span>
                <p className="mt-6 font-heading text-2xl italic text-forest">Coming Soon</p>
                <p className="mt-3 max-w-[26ch] text-sm leading-relaxed text-charcoal/55">
                  A new MAHIRA product is being crafted. Details revealed at
                  launch.
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
